import dotProp from 'dot-prop-immutable';

import {
    REDUCE_APPRAISAL,
    REDUCE_APPRAISAL_CLIENTS,
    REDUCE_APPRAISAL_QUERY_ELEMENT,
    REDUCE_APPRAISALS,
    REDUCE_CLIENT,
    REDUCE_CLIENT_CUSTOM_INFO,
    REDUCE_CLIENT_CUSTOM_INFO_ELEMENT,
    REDUCE_CLIENT_ELEMENT,
    REDUCE_CLIENT_LOG_CONTENT,
    REDUCE_CLIENT_LOGS,
    REDUCE_CLIENT_POLICIES,
    REDUCE_CLIENT_REFS,
    REDUCE_CLIENTS,
    REDUCE_CLIENTS_MORTGAGE_DTOS,
    REDUCE_ENTITY,
    REDUCE_PARAMETER,
    REDUCE_PARAMETERS,
    REDUCE_QUERY_ELEMENT,
    REDUCE_VELOCITY_INFO,
    REDUCE_VELOCITY_INFO_ELEMENT,
} from '../../constants/actions/client';

const initialState = {
    entity: null,
    parameters: [],
    client: null,
    clientRefs: null,
    query: {
        skip: 0,
        orderByDesc: true,
    },
    clients: [],
    clientpolicies: [],
    clientsMortgageDtos: [],
    customInfo: null,
    clientLogs: null,
    appraisals: [],
    appraisalQuery: {
        skip: 0,
        orderByDesc: true,
    },
    appraisal: null,
    appraisalClients: [],
    velocityInfo: null,
};

function clientReducer(state = initialState, action) {
    switch (action.type) {
        case REDUCE_ENTITY:
            return dotProp.set(state, 'entity', action.payload);
        case REDUCE_PARAMETER: {
            let parameterIndex = 0;
            if (state.parameters.some((x) => x.code === action.payload.code)) {
                parameterIndex = state.parameters.findIndex((x) => x.code === action.payload.code);
            } else {
                parameterIndex = state.parameters.length;
            }
            return dotProp.set(state, `parameters.${parameterIndex}`, {
                code: action.payload.code,
                value: action.payload.value,
            });
        }
        case REDUCE_PARAMETERS:
            return dotProp.set(state, 'parameters', action.payload);
        case REDUCE_CLIENT_ELEMENT:
            return dotProp.set(state, `client.${action.payload.code}`, action.payload.value);
        case REDUCE_CLIENT:
            return dotProp.set(state, 'client', action.payload);
        case REDUCE_CLIENT_POLICIES:
            return dotProp.set(state, 'policies', action.payload);
        case REDUCE_CLIENT_REFS:
            return dotProp.set(state, 'clientRefs', action.payload);
        case REDUCE_QUERY_ELEMENT:
            return dotProp.set(state, `query.${action.payload.code}`, action.payload.value);
        case REDUCE_CLIENTS:
            return dotProp.set(state, 'clients', action.payload);
        case REDUCE_CLIENTS_MORTGAGE_DTOS:
            return dotProp.set(state, 'clientsMortgageDtos', action.payload);
        case REDUCE_CLIENT_CUSTOM_INFO:
            return dotProp.set(state, 'customInfo', action.payload);
        case REDUCE_CLIENT_CUSTOM_INFO_ELEMENT:
            if (!state.customInfo) {
                state.customInfo = {};
            }
            return dotProp.set(state, `customInfo.${action.payload.code}`, action.payload.value);
        case REDUCE_CLIENT_LOGS:
            return dotProp.set(state, 'clientLogs', action.payload);
        case REDUCE_CLIENT_LOG_CONTENT: {
            const idx = state.clientLogs.findIndex((log) => log.eventCode === action.payload.code);
            return dotProp.set(state, `clientLogs.${idx}.logContent`, action.payload.value);
        }
        case REDUCE_APPRAISALS:
            return dotProp.set(state, 'appraisals', action.payload);
        case REDUCE_APPRAISAL_QUERY_ELEMENT:
            return dotProp.set(state, `appraisalQuery.${action.payload.code}`, action.payload.value);
        case REDUCE_APPRAISAL:
            return dotProp.set(state, 'appraisal', action.payload);
        case REDUCE_APPRAISAL_CLIENTS:
            return dotProp.set(state, 'appraisalClients', action.payload);
        case REDUCE_VELOCITY_INFO:
            return dotProp.set(state, 'velocityInfo', action.payload);
        case REDUCE_VELOCITY_INFO_ELEMENT:
            return dotProp.set(state, `velocityInfo.${action.payload.code}`, action.payload.value);
        default:
            return state;
    }
}

export default clientReducer;
